module.exports = __webpack_public_path__ + "static/img/image3.d902448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instruction_images/image3.png
// module id = obEc
// module chunks = 0